<template>
  <div class=""><span class="text-lg font-medium">{{ session.yogaType.title }}</span> with <span
      class="font-medium text-lg">{{ session.teacher.fullName }}</span></div>
  <div class="font-medium">{{ session.friendlyTime }}</div>
  <div class="flex gap-2">
    <div class="font-medium text-teal" :class="{ 'line-through' : voucherPriceFriendly != ''}">
      {{ session.priceFriendly }}
    </div>
    <div class="font-medium text-teal" v-if="voucherPriceFriendly != 0">{{ voucherPriceFriendly }}</div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';

import Spinner from './Spinner.vue';

const props = defineProps({
  session: Object,
  voucherPriceFriendly: Number,
});

onMounted(() => {
  // fetchSession()
});

// const fetchSession = () => {
//   // fetch from api/sessions/one?sessionId=props.sessionId
//   fetch('/api/sessions/all?sessionId=' + props.sessionId)
//       .then((response) => {
//         if (response.ok) {
//           return response.json();
//         }
//       })
//       .then((response) => {
//         console.log(response);
//         setTimeout(function() {
//           session.value = response.sessions[0];
//         }, 2000)
//
//       });
// }
</script>